import { render, staticRenderFns } from "./operateArea.vue?vue&type=template&id=7a6fd9f6&scoped=true&"
import script from "./operateArea.vue?vue&type=script&lang=js&"
export * from "./operateArea.vue?vue&type=script&lang=js&"
import style0 from "./operateArea.vue?vue&type=style&index=0&id=7a6fd9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6fd9f6",
  null
  
)

export default component.exports